import { useSelector } from 'react-redux'

import { selectMicroSurveyUnfollowTags } from './selectors'

export const useMicroSurveyUnfollowTags = () => useSelector(selectMicroSurveyUnfollowTags) || []
